<template>
  <h3>Search</h3>
  <div class="mini-calendar__search">
    <div class="mini-calendar__search-term">
        <input type="text" v-model.trim="searchValue" placeholder="Search Events" name="searchTerm" aria-label="Enter Search" @keyup.enter="onEnter">
    </div>
    <div class="mini-calendar__search-action">
        <button type="button" @click="onEnter"><IconSearch />Search</button>
    </div>
  </div>
</template>

<script>

import IconSearch from './icon/icon-search.vue'
import { mapActions } from 'vuex'
import { search } from './../api'

export default {
  name: 'MiniCalenderSearch',
  components: {
    IconSearch
  },
  data() {
    return {
      searchValue: ''
    }
  },
  methods: {
    onEnter() {
      this.setLoading(true);
      this.setClearAll();

      search(this.searchValue).then((result) => {
        this.setEventList({eventlist: result.data ? result.data: [], total: result.query.total});
        this.setSearch({search: this.searchValue});
        this.setFilter([]);
        this.$router.push("/");
        this.searchValue = "";
        this.setLoading(false);
      }).catch(() => {
        this.setLoading(false);
      });
    },
    ...mapActions(['setSearch', 'setEventList', 'setClearAll', 'setLoading', 'setFilter'])
  }
}
</script>
<style lang="scss">
  .mini-calendar__search {
    display: flex;
    margin: rem(10);
    background: none;
    border: 1px solid $border-color;

    &-term {
        width: calc(100% - 3.125rem);

        input {
            width: 100%;
            border: 0;
            border-radius: rem(5);
            padding: 0 rem(16);
            font-size: 1rem;
            line-height: rem(40);
            outline: 0;
            background: transparent;
            display: inline-block;
        }
    }

    &-action {
        width: 3.125rem;

        button {
          background: none;
          line-height: rem(40);
          padding: 0 rem(16);
          border: 0;
          height: 100%;
          display: flex;
          align-items: center;
          font-size: 0;
        }

        .icon {
          width: rem(16);
        }
    }
  }
</style>